import API from './api';

export default class Aweber extends API {
  constructor(config = {}) {
    config.path = 'v1/aweber';

    super(config);
  }
}



// WEBPACK FOOTER //
// ./src/services/request/aweber.js